import Chart from "chart.js/auto";
import { Controller } from "@hotwired/stimulus";

/**
 * @example
 * <%= content_tag(
 *   :canvas, '',
 *   data: {
 *     controller: 'chart',
 *     chart_target: 'canvas',
 *     chart_type_value: 'bar',
 *     chart_data_value: {
 *       labels: [...],
 *       datasets: [...]
 *     },
 *     chart_options_value: {...}
 *   }
 * ) %>
 */
export class ChartController extends Controller {
  static values = {
    type: String,
    data: Object,
    options: { type: Object, default: {} },
  };
  static targets = ["canvas"];

  connect() {
    const ctx = this.canvasTarget.getContext("2d");
    console.debug("options", this.optionsValue);
    this.chart = new Chart(ctx, {
      type: this.typeValue,
      data: this.dataValue,
      options: this.optionsValue,
    });
  }
}
